<template>
    <div>
        <el-page-header @back="close" content="批量导入"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="级别" prop="level.value" :error="errors.level" v-if="$root.isAdmin">
                        <RemoteSelect v-model="form.level.value" :url="'/dict/list/public/level'" @change="changeLevel"></RemoteSelect>
                    </el-form-item>
                  <el-form-item label="业务" prop="code" :error="errors.code" v-if="$root.isAdmin">
                    <Cascade v-model="form.code"></Cascade>
                  </el-form-item>
                    <el-form-item label="选择文件">
                        <el-upload ref="upload" :action="$utils.getApiPath('/blacklist/import')" :auto-upload="false"
                                   :data="data"
                                   :headers="headers" :file-list="fileList" accept=".txt,.csv,.xlsx" :limit="1"
                                   :on-success="onSuccess">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import RemoteSelect from '@/components/RemoteSelect'
    import Cascade from '@/components/Cascade'

    export default {
        components: {
          RemoteSelect,
          Cascade,
        },
        data() {
            return {
                form: {
                    level: {value: 'customer'},
                    code: this.$root.isAdmin ? "" : this.$root.code,
                },
                rules: {
                    "level.value": [
                        {required: true, message: "请选择级别"}
                    ],
                },
                errors: {},
                headers: {
                    Authorization: this.$utils.getAuthToken(),
                },
                fileList: []
            }
        },
        computed: {
            data() {
                return {
                    "level.value": this.form.level.value,
                    "code": this.form.code,
                }
            }
        },
        methods: {
            submit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.$refs.upload.submit();
                    }
                });
            },
            close() {
                this.$router.go(-1);
            },
            changeLevel(val) {
                if (val === "global") {
                    this.form.code = "";
                }
            },
            onSuccess() {
                this.$alert('后台导入中，请稍候查看黑名单列表！', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                        this.$router.go(-1);
                    }
                });
            }
        }
    }
</script>